export default __webpack_public_path__ + "d5625732b50be075dd54459713171be8.svg";